"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const RootStore_1 = require("../../stores/RootStore");
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const ContactForm_1 = require("../contactform/ContactForm");
const PublicPrivacyNoticeModalContentUtil_1 = require("./informationmodalcontents/PublicPrivacyNoticeModalContentUtil");
const PublicPrivacyNoticeInfoModal_1 = __importDefault(require("./PublicPrivacyNoticeInfoModal"));
const PrivacyChoicesAndRights = (props) => {
    const { publicPrivacyNoticeStore } = props;
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    (0, react_1.useEffect)(() => {
        publicPrivacyNoticeStore.isPublicPrivacyNoticeOpen = true;
        return () => {
            publicPrivacyNoticeStore.isPublicPrivacyNoticeOpen = false;
        };
    }, []);
    const getParagraphs = () => {
        return [
            {
                heading: translate('gdpr.privacy.accessData.heading'),
                content: translate('privacy.notices.paragraph.first.text'),
                linkText: translate('privacy.notices.link.text.first'),
                type: ContactForm_1.ContactFormType.ACCESS_DATA,
                modalHeading: translate('gdpr.privacy.accessData.heading')
            },
            {
                heading: translate('privacy.notices.paragraph.second.header'),
                content: translate('privacy.notices.paragraph.second.text')
            },
            {
                heading: translate('privacy.notices.paragraph.third.header'),
                content: translate('privacy.notices.paragraph.third.text'),
                linkText: translate('privacy.notices.link.text.third'),
                type: ContactForm_1.ContactFormType.CORRECT_DATA,
                modalHeading: translate('gdpr.privacy.notification.paragraph.nine.modal2.modal.defaultHeading')
            },
            {
                heading: translate('privacy.notices.paragraph.fourth.header'),
                content: translate('privacy.notices.paragraph.fourth.text'),
                linkText: translate('privacy.notices.link.text.fourth'),
                additionalText: translate('privacy.notices.paragraph.fourth.additionalText'),
                type: ContactForm_1.ContactFormType.CONTACT_US,
                modalHeading: translate('gdpr.privacy.notification.paragraph.nine.modal2.modal.defaultHeading')
            },
            {
                heading: translate('privacy.notices.paragraph.fifth.header'),
                content: translate('privacy.notices.paragraph.fifth.text'),
                linkText: translate('privacy.notices.link.text.fifth'),
                type: ContactForm_1.ContactFormType.FORGOTTEN,
                modalHeading: translate('gdpr.privacy.forgotten.heading')
            },
            {
                heading: translate('privacy.notices.paragraph.sixth.header'),
                content: translate('privacy.notices.paragraph.sixth.text'),
                linkText: translate('privacy.notices.link.text.sixth'),
                type: ContactForm_1.ContactFormType.LIMIT_PROCESSING,
                modalHeading: translate('gdpr.privacy.notification.paragraph.nine.modal2.modal.defaultHeading')
            },
            {
                heading: translate('privacy.notices.paragraph.seventh.header'),
                content: translate('privacy.notices.paragraph.seventh.text'),
                linkText: translate('privacy.notices.link.text.seventh'),
                type: ContactForm_1.ContactFormType.DATA_TRANSFER,
                modalHeading: translate('gdpr.privacy.notification.paragraph.nine.modal2.modal.defaultHeading')
            },
            {
                heading: translate('privacy.notices.paragraph.eighth.header'),
                content: translate('privacy.notices.paragraph.eighth.text')
            },
            {
                heading: translate('privacy.notices.paragraph.ninth.header'),
                content: translate('privacy.notices.paragraph.ninth.text')
            }
        ];
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(lib_1.Heading, { className: "h2 text-primary" }, translate('privacy.notices.header')),
        react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "small" }),
        getParagraphs().map((p, index) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(lib_1.Card, { key: `privacy-notice-card-${index}`, background: "primary-4" },
                    react_1.default.createElement(lib_1.CardContent, null,
                        react_1.default.createElement(lib_1.Heading, { element: "h2", className: "h4 text-bold" }, p.heading),
                        react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "xsmall" }),
                        react_1.default.createElement("p", { dangerouslySetInnerHTML: {
                                __html: p.content
                            } }),
                        !!p.linkText && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "xxsmall" }),
                            react_1.default.createElement(lib_1.Grid, { align: ['start-xs'] },
                                react_1.default.createElement(lib_1.GridColumn, { width: ['min-xs'] },
                                    react_1.default.createElement("span", null, p.linkText),
                                    "\u00A0",
                                    react_1.default.createElement(lib_1.ModalProvider, null,
                                        react_1.default.createElement(lib_1.ModalTrigger, null,
                                            react_1.default.createElement(GaButton_1.default, { id: "privacy-notice-paragraph-12-contact", link: true, onClick: () => publicPrivacyNoticeStore.openContactInformationModal(p.type, p.modalHeading), isUnderlined: true, text: translate('privacy.notices.infowindow') })),
                                        react_1.default.createElement(PublicPrivacyNoticeInfoModal_1.default, { type: PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.DATA_PROCESSING, heading: p.modalHeading })),
                                    !!p.additionalText && (react_1.default.createElement("p", { dangerouslySetInnerHTML: {
                                            __html: p.additionalText
                                        } })))))))),
                index + 1 <= getParagraphs().length && react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "small" })));
        })));
};
exports.default = (0, mobx_react_1.observer)(PrivacyChoicesAndRights);
